import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/Intro_IDE.mp4";
import videoSource1 from "../../assets/videos/IDE_Demo.mp4";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/image_extract.png";

const Image_Extract = () => {
  pageTitle("AI Image Data Extract");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        {/* <img src={AiInvoiceBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              AI-Powered <br /> Image Data Extract{" "}
            </h2>
            <p>Turn photos into structured data — instantly.</p>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            {/* <div className="siw-rpa-text"></div> */}

            <div className="siw-rpa-desc">
              <p>
                The Smart iLab Works <span className="SiW">(SiW)</span>{" "}
                AI-powered Azure Image Data Extract App is designed to instantly
                transform photos and images into structured, usable data. This
                tool bridges the gap between physical or unstructured visual
                documentation and digital systems like Excel or JSON databases.
              </p>

              <h3 className="pt-2">Key Capabilities</h3>
              <p className="py-2">
                The AI application utilizes Azure AI and Vision technology to
                detect and extract text, tables, and key values from a
                floorplans.
              </p>
              <p
                className="pb-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Four-Step Workflow{" "}
              </p>
              <ol className="mb-1">
                <li>
                  Capture and Upload: Users can upload the floorplan via a
                  mobile or web interface, which includes a preview feature.
                </li>
              </ol>
            </div>
          </div>
          <div className="col-md-5 col-12 siw-desktop-video">
            <div className="siw-project-video-wrapper">
              <video
                className="siw-project-video siw-project-video-contain"
                controls
              >
                <source src={videoSource1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          {/* <div className="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI-powered app.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>AI-Powered Image Data Extract</strong>, Click 👉{" "}
              <a
                href="https://ide.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Image Data Extract
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div> */}
        </div>
      </section>
      <div
        className="container"
        style={{ marginTop: "-10px", marginBottom: "30px" }}
      >
        <div className="siw-rpa-desc mt-1">
          <ol className="mb-1" start={2}>
            <li>
              AI Extraction: Using Azure AI / Vision, the system performs smart
              field mapping and validation to accurately identify and pull
              relevant information.
            </li>

            <li>
              Output Generation: The extracted data is automatically converted
              into a clean Excel sheet with proper columns, a structured JSON
              file for system integration, or detailed reports.
            </li>
            <li>
              Cloud Automation: The final files are automatically saved to cloud
              platforms such as OneDrive, SharePoint, or Azure Storage. To
              ensure high levels of organization, the system creates a folder
              structure categorized by Project, Site, and Date
            </li>
          </ol>
          <div className="siw-mobile-video mt-3">
            <div className="siw-project-video-wrapper">
              <video
                className="siw-project-video siw-project-video-contain"
                controls
              >
                <source src={videoSource1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <h3 className="mt-4 mt-md-0">Business Benefits</h3>
          <p className="py-2">
            By converting <span style={{ fontWeight: "bold" }}>floorplans</span>{" "}
            into structured data, businesses can eliminate manual data entry,
            reduce the risk of human error, and ensure that field data is
            immediately available for reporting and analysis. This creates a
            seamless transition from site activities to back-office processing.
          </p>
        </div>
      </div>
      {/* <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing AI-Powered Image Data Extract
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper siw-project-video-wrapper-portrait">
                <video
                  className="siw-project-video siw-project-video-contain"
                  controls
                >
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>AI-Powered Image Data Extract</strong>, Click 👉{" "}
            <a
              href="https://ide.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Image Data Extract
            </a>
            .
          </p>
        </div>
      </section> */}
      <FooterOne></FooterOne>
    </>
  );
};
export default Image_Extract;
